// Kept in sync by hand with Api::ProjectManager::AuditLogsController::AUDITED_TYPES -
// the models that were deliberately opted into PaperTrail tracking.
export const ITEM_TYPE_OPTIONS = [
  { value: 'Action', label: 'Action (budget line item)' },
  { value: 'CampaignScenarioActionGroup', label: 'Action Group' },
  { value: 'CampaignAuthentication', label: 'Campaign Authentication (pipeline status)' },
  { value: 'CampaignAuthenticationStatus', label: 'Pipeline Status Definition' },
  { value: 'Campaign', label: 'Campaign' },
]

export const EVENT_OPTIONS = [
  { value: 'create', label: 'Created' },
  { value: 'update', label: 'Updated' },
  { value: 'destroy', label: 'Deleted' },
]

// Single source of truth for the results table's column widths, shared between the
// header row and each entry row so they can't drift out of alignment with each other.
export const TABLE_COLUMNS = {
  chevron: 'w-4 shrink-0',
  when: 'w-40 shrink-0',
  event: 'w-24 shrink-0',
  model: 'w-56 shrink-0',
  record: 'flex-1 min-w-0',
  changedBy: 'w-40 shrink-0',
}

export const humanizeField = (field) =>
  field.replace(/_id$/, '').replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())

export const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}
